<script lang="ts">
  import { format } from "date-fns";
  import Stack from "../../components/Stack.svelte";
  import TextNew from "../../components/TextNew.svelte";
  import GiftIcon from "../../components/icons/GiftIcon.svelte";
  import BellIconLight from "../../components/icons/BellIconLight.svelte";
  import CardIcon from "../../components/icons/CardIcon.svelte";
  import Line from "./Line.svelte";

  export let reminderDate: Date;
  export let paidStartDate: Date;
</script>

<div class="container">
  <div class="bullet">
    <div class="step-icon-container success">
      <GiftIcon />
    </div>
    <Stack vertical>
      <TextNew size="s">today - 30 days free, cancel any time</TextNew>
      <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)"
        >get full access to REKKI Insights Premium</TextNew
      >
    </Stack>
  </div>
  <div class="line">
    <Line fill={0.5} />
  </div>

  <div class="bullet">
    <div class="step-icon-container">
      <BellIconLight />
    </div>
    <Stack vertical>
      <TextNew size="s">{format(reminderDate, "d MMM, yyyy")}</TextNew>
      <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)"
        >we'll send you a reminder 7 days before your free month ends</TextNew
      >
    </Stack>
  </div>
  <div class="line">
    <Line />
  </div>
  <div class="bullet">
    <div class="step-icon-container">
      <CardIcon />
    </div>
    <Stack vertical>
      <TextNew size="s">{format(paidStartDate, "d MMM, yyyy")}</TextNew>
      <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)"
        >your paid subscription starts</TextNew
      >
    </Stack>
  </div>
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 58px;
    min-height: 600px;
  }

  .bullet {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .line {
    margin-left: 24px;
    margin-bottom: 4px;
  }

  .step-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    border-radius: 13px;
    background-color: var(--rekki-light);
    margin-right: 15px;
    margin-bottom: 4px;
  }

  .success {
    background-color: var(--rekki-success);
  }
</style>
